import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getLoginPathForLocation, isStaffUser } from 'utils/authRedirect';

const ProtectedRoute = () => {
    const { token, user } = useSelector(state => state.auth || {}); 
    const location = useLocation();

    if (!token) {
        return <Navigate to={getLoginPathForLocation(location.pathname, location.search)} replace />;
    }

    if (isStaffUser(user) && location.pathname === '/dashboard') {
        return <Navigate to="/admin/dashboard" replace />;
    }

    return <Outlet />;
};

export default ProtectedRoute;
